import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";

const HonoraryDirectory = () => {
  return (
    <div>
      {AddPageHeader("Who are honorary consuls?")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>Who are honorary consuls?</h1>
        </Divider>
        <div className="privacy-terms-reduced-width">
          <p>
            Honorary consuls serve as voluntary representatives of a foreign
            state in a host country, facilitating diplomatic, cultural,
            economic, and political ties between the two nations.
          </p>
          <p>
            <b>Appointment and responsibilities</b>
          </p>
          <p>
            Unlike career diplomats, who are typically citizens of the sending
            state and part of a structured diplomatic corps, honorary consuls
            are often residents or citizens of the host country. Appointed by
            the sending state, honorary consuls typically serve for a fixed
            term. Their roles and responsibilities are recognized under the{" "}
            <Link
              to="/1961-and-1963-vienna-conventions"
              style={{
                color: "black",
                fontWeight: "bold",
              }}
            >
              1963 Vienna Convention on Consular Relations
            </Link>
            , which outlines their rights and limitations in international law.
            Their duties may include promoting trade and investment
            opportunities, supporting educational and cultural exchanges, and
            assisting citizens from the sending state. They may provide consular
            services, such as issuing passports and visas, and offer help during
            crises, such as natural disasters or political unrest.
          </p>
          <p>
            <b>Integration into local economic networks</b>
          </p>
          <p>
            Honorary consuls are often well-integrated into local economic
            networks, leveraging their personal and professional connections to
            strengthen bilateral relations. This integration allows them to
            support trade, investment, and cooperation in ways that career
            diplomats might not be able to, due to their frequent rotations
            between assignments. Honorary consuls often collaborate with
            business organizations and may help organize trade missions and
            other initiatives to promote bilateral ties.
          </p>
          <p>
            <b>Philanthropic and community engagement</b>
          </p>
          <p>
            In addition to their formal consular duties, honorary consuls
            frequently engage in philanthropic and community-oriented
            activities. Many work with charitable organizations, support
            educational institutions, and contribute to humanitarian efforts in
            their host country. These activities enhance diplomatic relations
            and foster goodwill between the two nations. Honorary consuls may
            also help organize cultural events, social programs, and community
            outreach initiatives, further strengthening the diplomatic bond
            between the sending and host states.
          </p>
          <p>
            <b>Limitations and privileges</b>
          </p>
          <p>
            While honorary consuls play an important role, they do not receive
            the same privileges and immunities as career diplomats. Some enjoy
            protections under international and bilateral agreements, but these
            are generally less extensive than those granted to career consular
            officers.
          </p>
          <p>
            As stated in Article 68 of the{" "}
            <Link
              to="/1961-and-1963-vienna-conventions"
              style={{
                color: "black",
                fontWeight: "bold",
              }}
            >
              1963 Vienna Convention on Consular Relations
            </Link>
            , it is essential to note that:
          </p>
          <p>
            "Each State is free to decide whether it will appoint or receive
            honorary consular officers."
          </p>
        </div>
      </div>
    </div>
  );
};

export default HonoraryDirectory;
